import { Get, Set } from "../../../../../Request";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export const useRules = () => {
  const [loading, setLoading] = useState({
    get: true,
    create: false,
    update: false,
  });
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [data, setData] = useState({ data: [] });
  const getData = () => {
    setLoading({ get: true });
    Get({
      url: "/roles/list",
    }).then(res => {
      setData(res);
      setLoading({ get: false });
    });
  };
  const create = async data => {
    setLoading({ create: true });
    await Set({
      url: "/roles/store",
      data: data,
    }).then(res => {
      setLoading({ create: false });
    });
  };
  const update = async data => {
    setLoading({ update: true });
    await Set({
      url: "/roles/update",
      data: { ...data, ...form },
    }).then(res => {
      setForm({});
      getData();
      setLoading({ update: true });
    });
  };
  const deleteRole = async data => {
    setLoading({ update: true });
    await Set({
      url: "/roles/delete",
      data: data,
    }).then(res => {
      setLoading({ update: true });
    });
  };
  const setAccess = async data => {
    setLoading({ update: true });
    await Set({
      url: "/roles/edit",
      data: data,
    }).then(res => {
      setLoading({ update: true });
    });
  };

  const isIn = ({ key }) => {
    let res = false;
    form &&
      form.access &&
      form.access.map(route => {
        if (route.key == key) {
          res = true;
        }
      });
    return res;
  };
  const toggle = obj => {
    if (isIn(obj)) {
      setForm({
        ...form,
        access: [...form.access].filter(data => data.key != obj.key),
      });
    } else {
      if (form.access) {
        setForm({ ...form, access: [...form.access, obj] });
      } else {
        setForm({ ...form, access: [obj] });
      }
    }
  };
  return {
    loading,
    getData,
    data,
    create,
    deleteRole,
    form,
    setForm,
    update,
    navigate,
    toggle,
    isIn,
    setAccess,
  };
};
